import { reversalItems } from '@/mocks/home';

const stageClasses: Record<string, string> = {
  已反转: 'bg-foreground-950 text-background-50',
  存疑: 'bg-secondary-500 text-background-50 dark:text-foreground-950',
  待核实: 'bg-primary-500 text-background-50 dark:text-foreground-950',
};

export default function ReversalTracker() {
  return (
    <section id="reversal" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-loop-left-line" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">反转追踪 · 前后说法对照</h2>
              <p className="mt-1 text-sm text-foreground-600">同一条事件，把「最初的说法」和「现在的最新进展」并排放在一起看。</p>
            </div>
          </div>
          <span className="flex h-8 items-center gap-2 self-start rounded-full border border-background-200 bg-background-50 px-3 font-label text-xs text-foreground-600 md:self-auto">
            <i className="ri-refresh-line" />
            今日新增反转 7 起
          </span>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
          {reversalItems.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <div className="flex flex-wrap items-center gap-2">
                <span className="flex h-6 items-center rounded-md bg-background-200 px-2 font-label text-[11px] text-foreground-700">
                  {item.topic}
                </span>
                <span
                  className={`flex h-6 items-center rounded-md px-2 font-label text-[11px] font-medium ${
                    stageClasses[item.stage] ?? 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {item.stage}
                </span>
                <span className="ml-auto font-label text-[11px] tabular-nums text-foreground-500">
                  最近更新 {item.updatedAt}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>

              <div className="mt-4 flex flex-col gap-3">
                <div className="rounded-md border border-background-200 bg-background-100 p-3">
                  <p className="flex items-center gap-1.5 font-label text-[11px] font-medium text-foreground-500">
                    <i className="ri-history-line" />
                    初版说法
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.first}</p>
                </div>
                <div className="flex justify-center">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-arrow-down-line text-sm" />
                  </span>
                </div>
                <div className="rounded-md border border-primary-200 bg-primary-50 p-3">
                  <p className="flex items-center gap-1.5 font-label text-[11px] font-medium text-primary-700">
                    <i className="ri-time-line" />
                    最新进展
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.latest}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}